/** 视口宽度大于该值走 PC 端，小于等于则走移动端 */
export const PC_BREAKPOINT = 1280

/**
 * 是否走移动端页面（按视口宽度，不按 UA / 机型）
 * 宽度 ≤ 1280 → mobile；宽度 > 1280 → PC
 */
export function isMobileDevice() {
  if (typeof window === 'undefined') return false
  return window.matchMedia(`(max-width: ${PC_BREAKPOINT}px)`).matches
}

/** 是否为 iOS / iPadOS 设备（含桌面 UA 模式，用于商店跳转） */
export function isIOSDevice() {
  if (typeof navigator === 'undefined') return false

  const ua = navigator.userAgent
  if (/iPad|iPhone|iPod/i.test(ua)) return true

  if (
    navigator.maxTouchPoints > 1 &&
    /Macintosh|Mac OS X/i.test(ua) &&
    /AppleWebKit/i.test(ua)
  ) {
    return true
  }

  return false
}
